import { getCurrentUser, API_BASE_URL } from './base';

export const saveFcmToken = async (fcmToken) => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(
      `${API_BASE_URL}/api/notification/store-fcm-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ token: fcmToken }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server response:", errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error saving token:", error);
    throw error;
  }
};

export const getNotifications = async (page) => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(
      `${API_BASE_URL}/api/notification?page=${page}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server response:", errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error getting token:", error);
    throw error;
  }
};

export const markNotificationRead = async (notificationId) => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(
      `${API_BASE_URL}/api/notification/mark-read/${notificationId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server response:", errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error updating token:", error);
    throw error;
  }
};

export const markAllNotificationsRead = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(
      `${API_BASE_URL}/api/notification/mark-all-read`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server response:", errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error marking all notifications as read:", error);
    throw error;
  }
};
